var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"kt_scrolltop",staticClass:"scrolltop",attrs:{"id":"kt_scrolltop"}},[_c('i',{staticClass:"fas fa-sort-up"})])
}
var staticRenderFns = []

export { render, staticRenderFns }